import { ProductItemComponentType, ProductVariantType, Maybe } from '~/@types/models'
export enum TitleNotePosition {
  BELOW_TITLE,
  IMAGE_BOTTOM,
}

export enum ImageSize {
  NONE = '',
  FULLSCREEN = 'FULLSCREEN',
  OVERHEAD = 'OVERHEAD',
  FRONT = 'FRONT',
}

export const imageSizeMap = {
  FULLSCREEN: 'productLifestyle',
  OVERHEAD: 'productOverhead',
  FRONT: 'productFront',
}

export enum GridLayoutConst {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  RUGS = 'rugs',
}

export type TGridLayout =
  | 'template-default'
  | 'template-furniture'
  | 'template-inStock'
  | 'template-rugs'
  | 'template-quickship'
  | 'template-lastChance'

export interface ProductItemsProps {
  variant?: string
  onItemClick?: () => void
  product: ProductItemComponentType
  visibleVariantsCount?: number
  productImageRatio?: number
  imageSize?: ImageSize
  titleNotePosition?: TitleNotePosition
  productVariant?: Maybe<ProductVariantType>
  collectionHandle?: string
  isNoScaleCustom?: boolean
  imageDimensions?: {
    width: [number, number]
    height: [number, number]
  }
  aspectRatio?: boolean
  showPrice?: boolean
  onlyCompareAtPriceVariants?: boolean
  mobileUseZoom?: boolean
  gridLayout?: TGridLayout
  footerNoMargin?: boolean
  tag?: string
  hiddenInfo?: boolean
  fontSize?: number
  template?: 'default' | 'bespoke'
}

export type UseProductLinkType = Pick<ProductItemsProps, 'product' | 'collectionHandle'> & {
  currentVariant?: ProductItemsProps['productVariant']
}
